
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
  directives: {},
})
export default class ContactAgentField extends Vue {
  @Prop() title!: string;
  @Prop() subtitle?: string;
  @Prop() infoIcon?: string;
  @Prop() content!: string;
  @Prop() capitalize?: boolean = false;
  @Prop() isPhone?: boolean;
}
